import type { AppRouteRecordRaw } from '@/router/types'
import { Layout } from '@/utils/routerHelper'

/** 投融资独立路由组 — 新窗口打开路径：/investment/dashboard */
const finStandaloneRoutes: AppRouteRecordRaw[] = [
  {
    path: '/investment',
    component: Layout,
    redirect: '/investment/dashboard',
    name: 'FinStandalone',
    meta: { title: '投融资', hidden: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/fin/cockpit/index.vue'),
        name: 'FinStandaloneDashboard',
        meta: { title: '投融资概况', hidden: true }
      }
    ]
  }
]

export default finStandaloneRoutes
